<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <header-add @openModal="openModal" v-if="isCreate()" />
        </div>
        <div v-if="isIndex()">
          <card-header
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          ></card-header>
          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
          >
            <template slot="addColumns">
              <table-column-badges
                prop="businesses[0].name"
                :label="$t('common_words.associated_companies2')"
                fromData="businesses"
                textBadge="name"
              />
            </template>
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
                :minWidth="110"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" />
        <export-tables
          :pdf="{
            filename: `${$t('sowing.pruning_add_motive')}.pdf`,
            route: 'pruning/reasons/pdf',
          }"
          :xls="{
            filename: `${$t('sowing.pruning_add_motive')}.xlsx`,
            route: 'pruning/reasons/excel',
          }"
        />
        <br />
      </card>
      <el-dialog
        width="45%"
        :title="getTitleDialog"
        :visible.sync="modals.create"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <form>
          <div class="row">
            <div class="col-6 col-sm-3 col-md-6">
              <fg-input
                type="text"
                :label="`${$t('common_words.name')}: *`"
                v-model="model.name"
                name="common_words.name"
                v-validate="modelValidations.name"
                :error="getError('common_words.name', true)"
                placeholder=" ..."
              >
              </fg-input>
            </div>
            <div v-if="businesses.length > 2" class="col-6 col-sm-3 col-md-6">
              <div class="form-group has-label">
                <label>{{ $t('common_words.companies2') }} *</label>
                <br />
                <el-select
                  collapse-tags
                  @change="
                    selectAllFromSelect('model.businesses_ids', businesses)
                  "
                  clearable
                  multiple
                  filterable
                  class="select-primary custom-width-select shadow-sm required-business"
                  size="large"
                  v-model="model.businesses_ids"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in businesses"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </form>
        <hr class="mb-0" />
        <dialog-button-form
          slot="footer"
          @closeModal="closeModal"
          @validate="validate"
        />
      </el-dialog>
      <el-dialog
        top="2%"
        v-if="isShow()"
        :title="$t('common_words.record_selected_threepoints')"
        :visible.sync="modals.read"
        width="60%"
      >
        <div class="card" v-if="rowData">
          <div class="card-body" v-if="rowData">
            <table class="table">
              <tbody>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.name') }}:</strong>
                    </h6>
                    {{ rowData.name }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.companies2') }}:</strong>
                    </h6>
                    <span v-for="(b, index) in rowData.businesses" :key="index">
                      <el-tag type="info">{{ b.name }}</el-tag>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer footer-date-at" v-if="rowData">
            <p class="text-white">
              <small
                >{{ $t('common_words.created_on') }}:
                {{ rowData.created_at }}</small
              >
            </p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification';
import { Pagination as LPagination } from 'src/components/index';
import ButtonForm from 'src/components/Dialogs/Forms/ButtonForm';
import Fuse from 'fuse.js';
import configTable from './pruningReason-table';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    [ButtonForm.name]: ButtonForm,
    LPagination,
  },
  computed: {
    ...configTable().Search,
    getTitleDialog() {
      return this.model.route
        ? i18n.t('sowing.prunning_edit')
        : i18n.t('sowing.pruning_add');
    },
  },
  data() {
    return {
      model: {
        name: null,
        businesses_ids: [],
        route: null,
      },
      modelValidations: {
        name: {
          required: true,
        },
      },
      pagination: {},
      tableColumns: [],
      businesses: [],
      tableData: [],
    };
  },

  mixins: [
    MixinMasters,
    MixinPermissions,
    MixinMenu,
    MixinExport,
    MixinNotification,
    MixinForm,
  ],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },

    openModal(name) {
      if (name == 'create') {
        this.$validator.reset();
        this.model.name = null;
        this.model.businesses_ids = this.selectElementsAsignFromModel(
          1,
          this.model.businesses_ids,
          this.businesses
        );
        this.model.route = null;
      }
      this.modals[name] = true;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.model.businesses_ids.length === 0) {
            return this.validationInputsRequired('business');
          } else {
            this.addPruningReason();
          }
        }
      });
    },

    handleView(_, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(_, row) {
      this.model.id = row.id;
      this.model.name = row.name;
      this.$set(
        this.model,
        'businesses_ids',
        row.businesses.map((business) => business.id)
      );
      this.errors.clear();
      this.model.route = 'pruning/reasons';
      this.modals['create'] = true;
    },

    handleDelete(_, row) {
      this.model = row;
      SweetAlert.disable(
        `${i18n.t('sowing.pruning_add_motive')}  "${this.model.name}"`
      ).then((result) => {
        if (result.value) this.deletePruningReason();
      });
    },

    handleActivate(_, row) {
      this.model = row;
      SweetAlert.default(
        `${i18n.t('sweet_alert.prunning.enable_prunning')}"${
          this.model.name
        }"?`,
        null,
        i18n.t('common_words.yes_enable'),
        1
      ).then((result) => {
        if (result.value) this.activatePruningReason();
      });
    },

    activatePruningReason() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.model.route = 'pruning/reasons/activate';
        Axios.updateMaster(this.model)
          .then((response) => this.modifyTable(1, this.model.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    addPruningReason() {
      this.showHideLoading(true);
      if (this.model.route == 'pruning/reasons') {
        if (this.isUpdate()) {
          Axios.updateMaster(this.model)
            .then((response) => {
              this.modifyTable(1, this.model.id, response);
              sessionStorage.removeItem('editForm');
            })
            .catch((error) => {
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          this.model.route = 'pruning/reasons';
          Axios.saveMaster(this.model)
            .then((response) => {
              this.modifyTable(0, null, response);
            })
            .catch((error) => {
              delete this.model.route;
              this.showMessageErrors(error);
            });
        }
      }
    },

    deletePruningReason() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'pruning/reasons';
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.modifyTable(1, this.model.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      }
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('pruning/reasons'),
        Axios.getMasters('businesses/only'),
      ])
        .then((response) => {
          const [response_pruningReason, response_businesses] = response;
          this.tableData = response_pruningReason.data.data;
          this.businesses = this.concatAll(response_businesses.data.data);

          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('pruning');
  },

  destroyed() {
    this.deselectedItemOnMenu('pruning');
  },
};
</script>
